import { z } from 'zod';

/**
 * Form-specific validation schema for Cycle forms
 * Simplified - cycles are just temporal groupers
 */
export const CycleFormSchema = z
  .object({
    name: z
      .string()
      .min(3, 'Nome deve ter pelo menos 3 caracteres')
      .max(100, 'Nome não pode ter mais de 100 caracteres')
      .trim(),

    description: z
      .string()
      .max(500, 'Descrição não pode ter mais de 500 caracteres')
      .trim()
      .optional()
      .or(z.literal('')),

    startDate: z.coerce.date({
      required_error: 'Data de início é obrigatória',
      invalid_type_error: 'Data de início inválida',
    }),

    endDate: z.coerce.date({
      required_error: 'Data de término é obrigatória',
      invalid_type_error: 'Data de término inválida',
    }),
  })
  .refine((data) => data.endDate > data.startDate, {
    message: 'Data de término deve ser posterior à data de início',
    path: ['endDate'],
  });

/**
 * TypeScript type inferred from CycleFormSchema
 */
export type CycleFormData = z.infer<typeof CycleFormSchema>;

/**
 * Default values for Cycle form initialization
 */
export const cycleFormDefaults: Partial<CycleFormData> = {
  name: '',
  description: '',
};
